import { FC } from 'react';
import { Breadcrumb, Card, PageHeader } from "antd";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import MessageForm from '../components/forms/message-form';

const MessagesFormRoute: FC = () => {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()

  const id = searchParams.get('id')
  return (
    <>
      <PageHeader
        title="فرم پیام"
        style={{ padding: " 16px 0" }}
        onBack={() => navigate(-1)}
        />
      <Card >
        <MessageForm id={id} />
      </Card>
    </>
  );
}

export default MessagesFormRoute;
